<div>
  <div class="success-graphic">
    <img src="assets/image/submit-success-dialog.png" alt="" />
    <div>
      {{ "success.thankYou" | translate }}
    </div>
  </div>
  <div class="success-content">
    @if (onOperation) {
      <span>
        {{
        "success.quotationsProcessed"
        | translate : { responseTime: responseTime }
        }}
        {{ "success.dropEmail" | translate }}
        <a href="mailto:info@policystreet.com">info&#64;policystreet.com</a>.
      </span>
    }
    @if (!onOperation) {
      <span>
        {{ "success.getBack" | translate }} {{ "success.dropEmail" | translate }}
        <a href="mailto:info@policystreet.com">info&#64;policystreet.com</a>.
      </span>
    }


    @if (redirect) {
      <button style="background: #FFD100;" mat-flat-button mat-primary mat-dialog-close (click)="onClose()">
        {{ "success.close" | translate }}
      </button>
    } @else {
      <button style="background: #FFD100;" mat-flat-button mat-primary mat-dialog-close>
        {{ "success.close" | translate }}
      </button>
    }
  </div>
</div>